import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  athlete: null
}

export const mutationTypes = {
  updateAthleteStart: '[update athlete] Update athlete start',
  updateAthleteSuccess: '[update athlete] Update athlete success',
  updateAthleteFailure: '[update athlete] Update athlete failure',

  getAthleteStart: '[update athlete] Get athlete start',
  getAthleteSuccess: '[update athlete] Get athlete success',
  getAthleteFailure: '[update athlete] Get athlete failure'
}

export const actionTypes = {
  updateAthlete: '[update athlete] Update athlete',
  getAthlete: '[update athlete] Get athlete'
}

const mutations = {
  [mutationTypes.updateAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getAthleteStart](state) {
    state.isLoading = true
    state.athlete = null
  },

  [mutationTypes.getAthleteSuccess](state, payload) {
    state.athlete = payload
    state.isLoading = false
  },

  [mutationTypes.getAthleteFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateAthlete](context, {id, athleteInput}) {
    context.commit(mutationTypes.updateAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .updateAthlete(id, athleteInput)
        .then(response => {
          context.commit(mutationTypes.updateAthleteSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getAthlete](context, {id}) {
    context.commit(mutationTypes.getAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .getArticle(id)
        .then(response => {
          context.commit(mutationTypes.getAthleteSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getAthleteFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
